import Flex from 'antd/lib/flex'
import Skeleton from 'antd/lib/skeleton'
import React from 'react'

type CardTagPropsType = {
    count?: number
    width?: number
}

export const CardListSkeleton: React.FC<CardTagPropsType> = ({ count = 10, width = 780 }) => {
    return (
        <Flex gap={20} vertical style={{ maxWidth: `${width}px` }} data-testid="card-list-skeleton">
            {Array.from({ length: count }).map((_, index) => (
                <Skeleton active key={index} />
            ))}
        </Flex>
    )
}
